import { render, staticRenderFns } from "./commandbar.vue?vue&type=template&id=de4fab80&"
import script from "./commandbar.vue?vue&type=script&lang=js&"
export * from "./commandbar.vue?vue&type=script&lang=js&"
import style0 from "./commandbar.vue?vue&type=style&index=0&id=de4fab80&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de4fab80')) {
      api.createRecord('de4fab80', component.options)
    } else {
      api.reload('de4fab80', component.options)
    }
    module.hot.accept("./commandbar.vue?vue&type=template&id=de4fab80&", function () {
      api.rerender('de4fab80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/commands/commandbar.vue"
export default component.exports